export const setDocumentTitle = function(title) {
  document.title = title
  const ua = navigator.userAgent
  // eslint-disable-next-line
  const regex = /\bMicroMessenger\/([\d\.]+)/
  if (regex.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
    const i = document.createElement('iframe')
    i.src = '/souce/favicon.ico'
    i.style.display = 'none'
    i.onload = function() {
      setTimeout(function() {
        i.remove()
      }, 9)
    }
    document.body.appendChild(i)
  }
}
export function device() {
  let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag ? "mobile" : "pc";
}
/**
 * 获取uuid
 */
export function getUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16) | 0 : 'r&0x3' | '0x8').toString(16)
  })
}
/**
 * 获取16uuid
 */
 export function get16UUID() {
  return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16) | 0 : 'r&0x3' | '0x8').toString(16)
  })
}
export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}
export function isIE() {
  const bw = window.navigator.userAgent
  const compare = s => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}


// 格式化金额 000,000,000.00
export function currency(value, currency, decimals) {
  const digitsRE = /(\d{3})(?=\d)/g
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  currency = currency != null ? currency : ''
  decimals = decimals != null ? decimals : 2
  const stringified = Math.abs(value).toFixed(decimals)
  const _int = decimals ? stringified.slice(0, -1 - decimals) : stringified
  const i = _int.length % 3
  const head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : ''
  const _float = decimals ? stringified.slice(-1 - decimals) : ''
  const sign = value < 0 ? '-' : ''
  return sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float
}
// 金额大写
export function digitUppercase(n) {
  var fraction = ['角', '分']
  var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  var unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟']
  ]
  var head = n < 0 ? '欠' : ''
  n = Math.abs(n)
  var s = ''
  for (let i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(shiftRight(n, 1 + i)) % 10] + fraction[i]).replace(/零./, '')
  }
  s = s || '整'
  n = Math.floor(n)
  for (let i = 0; i < unit[0].length && n > 0; i++) {
    var p = ''
    for (var j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p
      n = Math.floor(shiftLeft(n, 1))
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
  }
  return (
    head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整')
  )
}


/**
 * 数组格式转树状结构
 * @param   {array}     array
 * @param   {String}    id
 * @param   {String}    pid
 * @param   {String}    children
 * @return  {Array}
 */
 export function arrayToTree(array, id = 'id', pid = 'pid', children = 'children') {
  const data = _.cloneDeep(array)
  const result = []
  const hash = {}
  data.forEach((item, index) => {
    item.index = index
    hash[data[index][id]] = data[index]
  })

  data.forEach(item => {
    const hashVP = hash[item[pid]]
    if (hashVP) {
      if(!hashVP[children]) {
        hashVP[children] = [item]
      } else {
        hashVP[children].push(item)
      }
    } else {
      result.push(item)
    }
  })
  return result
}
/**
 * 树状结构转数组格式
 * @param   {array}     tree
 * @param   {String}    id
 * @param   {String}    pid
 * @param   {String}    children
 * @return  {Array}
 */
export function treeToArray(tree, result = [], id = 'id', pid = 'pid', children = 'children') {
  if (!tree || !tree.length) return result
  tree.forEach((item, index) => {
    result.push(item)
    if (item[children] && item[children].length > 0) {
      treeToArray(item[children].map(_item => {
        _item[pid] = item[id]
        return _item
      }), result, id, pid, children)
    }
  })
  return result
}

export function coordinateInTree(array, leafId, id = 'id', pid = 'pid') {
  let temp = []
  array.forEach(item => {
    if (leafId === item[id]) {
      temp.push(item[id])
      temp = temp.concat(coordinateInTree(array, item[pid]))
      return temp
    }
  })
  return temp
}



/**
 * 文件下载 
 * @param {string} filename 下载后的文件名称
 * @param {string} text 文件内容html 或者 xml
 * 
 */
export function download(filename, text) {
  var element = document.createElement("a");
  element.setAttribute(
    "href",
    "data:text/plain;charset=utf-8," + encodeURIComponent(text)
  );
  element.setAttribute("download", filename);
  element.style.display = "none";
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

/**
 * 判断内容是否是JSON STRING
 * @param {string} str 需要判断的字符串
 */
export function isJSON(str) {
  if (typeof str == "string") {
    try {
      var obj = JSON.parse(str);
      if (typeof obj == "object" && obj) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      // console.log("error：" + str + "!!!" + e);
      return false;
    }
  }
  //console.log("It is not a string!");
}

/**
 * 拖动内容，滚动条滚动，横向
 * mouseX, mouseY 点击鼠标左键时, 鼠标的定位
 * @param {string} container 需要拖动的面板
 */
 export function dragMove(container) {
  var mouseX, mouseY, boxX, boxY
  const boxes = document.getElementsByClassName(container)
  Array.from(boxes).every(
    box =>
      (box.onmousedown = function(event) {
        mouseX = event.clientX
        mouseY = event.clientY
        boxX = box.offsetLeft
        boxY = box.offsetTop
      })
  )
  Array.from(boxes).every(
    box =>
      (box.ondrag = function(event) {
        if (event.clientX) box.style.left = (boxX + (event.clientX - mouseX)) + 'px'
        if (event.clientY) box.style.top = (boxY + (event.clientY - mouseY)) + 'px'
      })
  )
  Array.from(boxes).every(
    box =>
      (box.mouseleave = function(event) {
        box.removeEventListener('ondrag')
      })
  )
}



/**
 * 加载第三方js文件 src 为js路径string 加载成功 及 失败对应方法
 * @param {*} src 
 * @returns 
 */
export function loadJs(src) {
  return new Promise((resolve, reject) => {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = src;
    document.body.appendChild(script);
    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      reject();
    };
  });
}